import { render } from "./VideoTranscript.vue?vue&type=template&id=177f4935"
import script from "./VideoTranscript.vue?vue&type=script&lang=js"
export * from "./VideoTranscript.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__